import _ from "underscore";
import SimpleCheckboxNodeRenderer from "./SimpleCheckboxNodeRenderer";
import messageResource from "../../messageResource";
import {escapeHtmlSymbols} from "../../atUtils";

export default class DisabledNodesParentNodeRenderer extends SimpleCheckboxNodeRenderer {
    constructor(tree, selectorFilter, selectionHelper) {
        super(tree, selectorFilter, selectionHelper);
    }

    generateLabel(treeNode, labelEl) {
        const text = messageResource.getMessage(this.labelMessageKey(), [this.labelCounterValue(treeNode)]);
        labelEl.innerHTML = escapeHtmlSymbols(text);
        labelEl.title = text;
    }

    labelMessageKey() {
        // Abstract
    }

    labelCounterValue(treeNode) {
        if (this.tree.hasActiveFilter()) {
            let result = 0;
            _.each(treeNode.getChildren(), function(childNode) {
                if (this.tree.doesMatchFilterCriteria(childNode) || this.tree.doesContainChildrenMatchingFilterCriteria(childNode))
                    result++;
            }, this);
            return result;
        }
        else {
            return treeNode.getChildren().length;
        }
    }

    getNodeClasses(treeNode) {
        const classes = super.getNodeClasses(treeNode);
        classes.push("disabledNodesParent");
        if (this.tree.hasActiveFilter() && !this.tree.doesContainChildrenMatchingFilterCriteria(treeNode))
            classes.push("emptyDisabledNodesParent");
        return classes;
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/DisabledNodesParentNodeRenderer.js